import React from 'react';
import { Row } from 'react-table';
import classNames from 'classnames';

import { CheckboxRadioInput } from '../../checkbox-radio-input';

interface HeaderSelectCheckboxProps {
  rows: Row<object>[];
  isRowSelectable: (row: Row<object>) => boolean;
  toggleRowSelected: (rowId: string, set?: boolean) => void;
}

export const HeaderSelectCheckbox: React.FC<HeaderSelectCheckboxProps> = ({
  rows,
  isRowSelectable,
  toggleRowSelected,
}) => {
  const selectableRows = rows.filter(isRowSelectable);
  const areAllSelectableRowsSelected = selectableRows.every(
    (row) => row.isSelected
  );
  const disabled = selectableRows.length === 0;
  const checked = !disabled && areAllSelectableRowsSelected;
  const indeterminate = !checked && rows.some((row) => row.isSelected);
  const onChange = () => {
    rows.forEach(
      (row) =>
        isRowSelectable(row) &&
        toggleRowSelected(row.id, !areAllSelectableRowsSelected)
    );
  };
  return (
    <CheckboxRadioInput
      disabled={disabled}
      indeterminate={indeterminate}
      checked={checked}
      className={classNames(
        disabled ? 'cursor-auto' : 'cursor-pointer',
        'block'
      )}
      onChange={onChange}
    />
  );
};
